import { render, staticRenderFns } from "./ModalTambahProdukBuatKonten.vue?vue&type=template&id=deab67c4&scoped=true&"
import script from "./ModalTambahProdukBuatKonten.vue?vue&type=script&lang=js&"
export * from "./ModalTambahProdukBuatKonten.vue?vue&type=script&lang=js&"
import style0 from "./ModalTambahProdukBuatKonten.vue?vue&type=style&index=0&id=deab67c4&scoped=true&lang=css&"
import style1 from "./ModalTambahProdukBuatKonten.vue?vue&type=style&index=1&lang=css&"
import style2 from "./ModalTambahProdukBuatKonten.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deab67c4",
  null
  
)

export default component.exports